module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2023-10-25 at 2.05.14 PM.7d7cdc92.jpeg";